exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".instalments-list[data-v-27f739b7]{margin-bottom:20px}.instalments-list .instalments-list-item[data-v-27f739b7]{padding-bottom:10px}.instalments-list .instalments-list-item .instalment-date[data-v-27f739b7]{display:inline-block;min-width:90px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-27f739b7","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Checkout/Gateway/Stripedirectdebit.vue
// module id = nDUP
// module chunks = 116